import axios from 'axios';
import AppConfig from "../../../../config/AppConfig";
// import Config from '@/common/config.json'

function getBaseURL() {
    // return process.env.NODE_ENV === "development" ? 'http://flow123456.com' : 'https://flow.51homemoney.com'
    return process.env.NODE_ENV === "development" ? AppConfig.erp_server+'/butler4/' : AppConfig.erp_server+'/butler4/'
}

const instance = axios.create({
    baseURL: getBaseURL() //+ '/contract/'
});

const ErrorResponse = {code: 400, msg: '网络错误'}

instance.interceptors.request.use(function (config) {
    if(!config.params) config.params = {}
    config.params.login = localStorage.getItem('login')
    config.params.token = localStorage.getItem('token')
    return config;
});

function DateFormat(date) {
    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let sdate = ("0" + date.getDate()).slice(-2);
    return year + '-' + month + '-' + sdate
}

function get(url, data, callback) {
    instance.get(url, {params: data}).then(resp => {
        callback(resp.data)
    }).catch(error => callback(ErrorResponse))
}

function post(url, data, callback) {
    instance.post(url, data).then(resp => {
        callback(resp.data)
    }).catch(error => callback(ErrorResponse))
}

/**
 * ButlerHttp
 */
export default class ButlerHttp {
    /**
     * 获取基础URL
     * @returns {string}
     */
    static getBaseURL(){
        return getBaseURL()
    }
    /**
     * 发送get请求
     * @param url - 接口地址
     * @param data - 请求参数
     * @param callback - 回调函数
     */
    static get(url, data, callback){
        get(ButlerHttp.enUrl(url), data, callback)
    }
    /**
     * 发送post请求
     * @param url - 接口地址
     * @param data - 请求参数
     * @param callback - 回调函数
     */
    static post(url, data, callback){
        post(ButlerHttp.enUrl(url), data, callback)
    }
    /**
     * 加密url
     * @param url
     * @returns {string}
     */
    static enUrl(url){
        let login = localStorage.getItem('login')
        let token = localStorage.getItem('token')
        if(url.indexOf('http')!==-1){
            return url;
        }else {
            if(url.indexOf("?")===-1){
                return getBaseURL()+url+`?login=${login}&token=${token}`
            }else {
                return getBaseURL()+url+`&login=${login}&token=${token}`
            }
        }
    }

    /**
     * 上传文件
     * @param callback
     */
    static uploadFile(callback){
      let upload=document.getElementById("uploadFile-9999");
      if(!upload){
        upload=document.createElement('input');
        upload.type="file";
        upload.id="uploadFile-9999";
        upload.style.display="none";
      }
      upload.click();
      upload.onchange=function (e) {
        let formData = new FormData();
        formData.append("file",this.files[0]);
        axios.post(AppConfig.erp_server+'/butler/index/uploadFile',formData).then(res=>{
          if(res){
            typeof callback==="function"&&callback(res.data.data.path)
          }
        },err=>{

        })

        upload.onchange=undefined;

      }

    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Butler/common/ButlerHttp.js